<ng-content select=".section-divider"></ng-content>

<form>
  <div
    *ngFor="let group of formArray$ | async; let i = index"
    [formGroup]="group"
    class="group-scrap-reason"
  >
    <button
      *ngIf="i > 0"
      mat-icon-button
      class="btn-remove-reason"
      (click)="removeNewReason(i)"
    >
      <mat-icon>delete</mat-icon>
    </button>

    <mat-form-field class="quantity" appearance="fill">
      <mat-label>{{ "COMMON.QUANTITY" | translate }}</mat-label>
      <input
        matInput
        formControlName="quantity"
        min="1"
        type="number"
        [max]="maxQuantity"
      />
    </mat-form-field>

    <mat-form-field class="reason" appearance="fill">
      <mat-label>{{ "COMMON.REASON_SCRAP" | translate }}</mat-label>

      <mat-select formControlName="reason">
        <mat-option>
          <ngx-mat-select-search
            [formControl]="searchReasonControl"
            placeholderLabel="Buscar..."
            noEntriesFoundLabel="Sin resultados"
          >
          </ngx-mat-select-search>
        </mat-option>

        <mat-option
          *ngFor="let reason of reasonsFiltered$ | async"
          [value]="reason"
          [disabled]="notSelectableReasonsIds.includes(reason.id)"
        >
          {{ reason.title }} --- Código: {{ reason.code }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <button
    mat-raised-button
    class="btn-add-reason"
    (click)="addNewReason()"
    [disabled]="validateAdd$ | async"
  >
    <mat-icon>add</mat-icon>
  </button>
</form>
